import React, { useEffect, useState } from 'react';

const InlineDots = () => {
  const [dots, setDots] = useState<string>('');

  useEffect(() => {
    setDots('.');
    let count = 1;

    const intervalId = setInterval(() => {
      let localDots = '';
      count = count < 3 ? count + 1 : 1;
      for (let i = 0; i < count; i += 1) localDots += '.';
      setDots(localDots);
    }, 300);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <span>{dots}</span>
  );
};

export default InlineDots;
